export default __webpack_public_path__ + "static/media/delivery-small-icon-orange.85f9ff50.svg";